import React, { useState } from 'react';
import TestCards from '../CompanyHome/TestCards';
import { ScheduleTest } from '../Screening/Popup/ScheduleTest';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Heading, Text } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

const ScheduleTestt = ({ candidates, jobDetails, onClose }) => {
  const navigate = useNavigate();
  // Ensure candidates is always an array.
  const appliedCandidates = candidates || [];

  const [selectedTestCard, setSelectedTestCard] = useState(null);
  const [showScheduleTestPopup, setShowScheduleTestPopup] = useState(false);

  // Parse jobId from the URL query string
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const jobId = queryParams.get('jobID');

  const handleSelectTestCard = (card) => {
    setSelectedTestCard(card);
    setShowScheduleTestPopup(true);
  };

  const handleCloseScheduleTestPopup = () => {
    setShowScheduleTestPopup(false);
  };
  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className={cn("sm:max-w-[600px] max-h-[90vh] overflow-y-auto")}>
        <DialogHeader>
          <DialogTitle><Heading level="h2">Schedule Test</Heading></DialogTitle>
          <DialogDescription>
            <Text>Schedule tests for selected candidate(s)</Text>
          </DialogDescription>
        </DialogHeader>
        <div className={cn("py-4")}>
          <TestCards onSelectTestCard={handleSelectTestCard} />
          {showScheduleTestPopup && (
            <ScheduleTest
              onClose={handleCloseScheduleTestPopup}
              selectedEmails={appliedCandidates}
              jobDetails={jobDetails}
              selectedTestCard={selectedTestCard}
              jobId={jobId}
            />
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ScheduleTestt;